import { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import * as Sentry from '@sentry/react';

const DEFAULT_RESPONSIBILITY = {
    tenant: { due: 0, overdue: 0, pendingVerification: 0 },
    landlord: { due: 0, overdue: 0, pendingVerification: 0 }
};

const AssetServices = ({ period }) => {
    const { apiFetch } = useAuth();
    const [combinedTotals, setCombinedTotals] = useState({
        due: 0, overdue: 0, pendingVerification: 0,
        byResponsibility: DEFAULT_RESPONSIBILITY
    });

    const fetchCombinedTotals = async () => {
        try {
            const response = await apiFetch('/api/Ops/GetCombinedAssetServiceStatus');
            const data = await response.json();
            if (data.success && data.data?.totals) {
                setCombinedTotals(prev => ({
                    ...prev,
                    ...data.data.totals,
                    byResponsibility: data.data.totals.byResponsibility ?? prev.byResponsibility
                }));
            }
        } catch (e) {
            Sentry.captureException(e);
            console.error('Error fetching combined asset totals:', e);
        }
    };

    useEffect(() => {
        if (!period) return;
        const timer = setTimeout(() => {
            fetchCombinedTotals();
        }, 0);
        return () => clearTimeout(timer);
    }, [period]);

    const { tenant, landlord } = combinedTotals.byResponsibility ?? DEFAULT_RESPONSIBILITY;

    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th>Asset Services</th>
                        <th>Assets Due</th>
                        <th>Assets Overdue</th>
                        <th>Pending Verification</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Landlord responsibility</td>
                        <td>{landlord.due}</td>
                        <td>{landlord.overdue}</td>
                        <td>{landlord.pendingVerification}</td>
                    </tr>
                    <tr>
                        <td>Tenant responsibility</td>
                        <td>{tenant.due}</td>
                        <td>{tenant.overdue}</td>
                        <td>{tenant.pendingVerification}</td>
                    </tr>
                    <tr>
                        <td>Total Assets</td>
                        <td>{combinedTotals.due}</td>
                        <td>{combinedTotals.overdue}</td>
                        <td>{combinedTotals.pendingVerification}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default AssetServices;